module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-body"
  }, [_c('el-row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'inventory.stock.create'
      }
    }
  }, [_c('a', [_c('el-col', {
    staticClass: "el-card box-card is-always-shadow",
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "el-card__body"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('static.stock.filters.create')))]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-file-text-o fa-3x"
  })])])], 1)]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'inventory.adjustment.stock.create'
      }
    }
  }, [_c('a', [_c('el-col', {
    staticClass: "el-card box-card is-always-shadow",
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "el-card__body"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('static.adjustment.filters.create')))]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-adjust fa-3x"
  })])])], 1)]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'inventory.purchase.create'
      }
    }
  }, [_c('a', [_c('el-col', {
    staticClass: "el-card box-card is-always-shadow",
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "el-card__body"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('static.purchase.filters.create')))]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-shopping-cart fa-3x"
  })])])], 1)]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'inventory.transfer.create'
      }
    }
  }, [_c('a', [_c('el-col', {
    staticClass: "el-card box-card is-always-shadow",
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "el-card__body"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('static.transfer.filters.create')))]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-exchange fa-3x"
  })])])], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5561f962","hasScoped":true}!./src/app/pages/withNavigation/transaction/index/index.html
// module id = 3013
// module chunks = 1